// extracted by mini-css-extract-plugin
export default {"mySection":"MySection_mySection__kEXot","outlet":"MySection_outlet__qSGqw"};